import { AddNew16 } from 'ui/icons/aurora/16px';
import { Tooltip } from 'ui/tooltip';
import { SecondaryButton } from 'ui/button';
import {
  CREATE_NEW_COLLECTION_TEXT,
  MISSING_MANAGE_CATALOGS_PERMISSION,
} from 'modules/catalog/catalogConstants';

type AllCatalogsTableButtonRowProps = {
  canManageCatalogs: boolean;
  isCatalogCollectionsFlagOn: boolean;
  openCreateCollectionModal: () => void;
};

export const AllCatalogsTableButtonRow = ({
  canManageCatalogs,
  isCatalogCollectionsFlagOn,
  openCreateCollectionModal,
}: AllCatalogsTableButtonRowProps) => {
  return isCatalogCollectionsFlagOn ? (
    <Tooltip isEnabled={!canManageCatalogs} tooltipContent={MISSING_MANAGE_CATALOGS_PERMISSION}>
      <SecondaryButton
        data-test="createCollectionButton"
        isDisabled={!canManageCatalogs}
        onClick={openCreateCollectionModal}
      >
        <AddNew16 />
        {CREATE_NEW_COLLECTION_TEXT}
      </SecondaryButton>
    </Tooltip>
  ) : null;
};
